import { ReactNode } from "react";

interface HeadingProps {
  level?: "h2" | "h3";
  children: ReactNode;
  className?: string;
}

export function Heading({ level = "h2", children, className = "" }: HeadingProps) {
  const baseStyles = "font-bold mb-8";
  const styles = {
    h2: `text-3xl ${baseStyles}`,
    h3: `text-2xl font-semibold mb-6 text-gray-800 dark:text-gray-300`,
  };

  const Tag = level as keyof JSX.IntrinsicElements; // Ensure it's a valid HTML tag
  return <Tag className={`${styles[level]} ${className}`}>{children}</Tag>;
}

interface ParagraphProps {
  children: ReactNode;
  className?: string;
}

export function Paragraph({ children, className = "" }: ParagraphProps) {
  return <p className={`text-gray-600 dark:text-gray-400 ${className}`}>{children}</p>;
}
